import {Typography} from "@mui/material";

interface Props {
  total: number,
  current: number
}

export default function TextFieldLimitLabel({total, current}: Props) {

  return <Typography>
    <span>{current}</span>
    <span>/</span>
    <span>{total}</span>
  </Typography>
}